<template>
  <NrPanel class="m-bottom-24" v-if="canSeeActivePinnedNote">
    <template v-slot:header>Pin board</template>
    <TimelineCard
      :canPin="canUpdatePins"
      :pinned="pinnedNote.timeline_is_pinned"
      :collapsable="
        canCollapse(
          pinnedNote.timeline_is_collapsable,
          pinnedNote.timeline_display_text
        )
      "
      :collapsed="false"
      :id="pinnedNote.timeline_id"
      :with-actions="canSeeTimelineActions(pinnedNote)"
      editIcon
      :deleteIcon="false"
      color="orange"
      icon-name="edit"
      :header="pinnedNote.timeline_name"
      :subheader="pinnedNote.timeline_subheader"
      :header-right="pinnedNote.timeline_state"
      :footer-left="pinnedNote.timeline_byline"
      @on-edit="handleEditMessageText"
      @on-collapse="handleCollapse"
      @on-pin-click="handlePinChange(pinnedNote)"
    >
      <!-- pinnedNote.timeline_display_text is sanitized on the backend: https://github.com/nextrequest/nextrequest/blob/726ba59/app/views/client/timeline/_note_pinned_event.json.jbuilder#L6 -->
      <div
        class="wrap-text quill-content"
        v-if="!isCollapsed"
        v-html="pinnedNote.timeline_display_text"
      />
    </TimelineCard>
  </NrPanel>
</template>
<script>
import NrPanel from '@nextrequestco/components/src/components/NrPanel'
import TimelineCard from './TimelineCard'
import { mapState, mapActions, mapMutations } from 'vuex'
import isEmpty from 'lodash/isEmpty'

export default {
  components: { NrPanel, TimelineCard },
  data() {
    return {
      isCollapsed: false
    }
  },
  computed: {
    ...mapState('request_show', ['pinnedNote']),
    ...mapState(['account']),
    canSeeActivePinnedNote() {
      return !isEmpty(this.pinnedNote) && this.canReadPins
    },
    canReadPins() {
      return (
        this.account.pinning_notes_feature_flag &&
        this.pinnedNote.timeline_name === 'Note' &&
        this.$ability.can('read', 'RequestEventPin')
      )
    },
    canUpdatePins() {
      return (
        this.account.pinning_notes_feature_flag &&
        this.pinnedNote.timeline_name === 'Note' &&
        this.$ability.can('update', 'RequestEventPin')
      )
    }
  },
  methods: {
    ...mapActions('request_show', ['handlePinChange', 'setCurrentAction']),
    ...mapMutations('request_show', ['setSelectedTimelineEvent']),
    canSeeTimelineActions() {
      return this.$ability.can('read', 'publisher_only_items')
    },

    canCollapse(typeCanCollapse, content) {
      return (
        typeCanCollapse || (!typeCanCollapse && (content || '').length >= 200)
      )
    },

    handleCollapse() {
      this.isCollapsed = !this.isCollapsed
    },

    handleEditMessageText() {
      this.setSelectedTimelineEvent(this.pinnedNote)
      this.setCurrentAction('editMessageText')
    }
  }
}
</script>
